import React from 'react';
import { Tag } from 'antd';
import classNames from 'classnames';
import { capitalize } from '@shared/utils/string';
import {
	AccountingItemApprovalStates,
	HireInvoiceItemStates,
} from '@shared/utils/constants';
import { Values } from '@shared/utils/objectEnums';
import styles from './ApprovalStateTag.module.css';

type StateTypes = (
	Values<typeof AccountingItemApprovalStates> |
	Values<typeof HireInvoiceItemStates> |
	string |
	'estimated' |
	undefined
);

const getStateColor = (
	state: StateTypes,
) => {
	switch (state) {
		case undefined:
			return 'orange';
		case 'estimated':
			return 'cyan';
		case AccountingItemApprovalStates.PAID:
			return 'green';
		case AccountingItemApprovalStates.APPROVED:
			return 'blue';
		case AccountingItemApprovalStates.PENDING:
			return 'orange';

		case AccountingItemApprovalStates.SUBMITTED:
			return 'purple';

		case AccountingItemApprovalStates.REJECTED:
			return 'red';

		case AccountingItemApprovalStates.PARTIAL:
			return 'cyan';

		case AccountingItemApprovalStates.OVERPAID:
			return 'red';

		default:
			return 'grey';
	}
};

const ApprovalStateTag = ({
	state,
	className,
}: {
	state: StateTypes; showUnresolved?:boolean;
	className?: string;
}) => {
	return (
		<Tag className={classNames(styles.tag, className)} color={getStateColor(state)}>
			{capitalize(state ?? AccountingItemApprovalStates.PENDING)}
		</Tag>
	);
};

export default ApprovalStateTag;
